import { useSelector } from 'react-redux';

import { selectProjects } from 'core/userContext';

/**
 * React hook that returns a Redux-bound callback function for determining
 * whether or not the current user is allowed to access a given project ID.
 *
 * Please note: the current project must be loaded into the Redux store
 * before this callback can be used.
 */
export const useCanUserAccessProject = () => {
  const projectIdsForCurrentUser = useSelector(selectProjects)?.map(({ id }) => id);
  return (projectId: number) =>
    !!projectIdsForCurrentUser?.some(
      (projectIdForCurrentUser) => projectId === projectIdForCurrentUser,
    );
};
